"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.BoostMobilePricingTable = void 0;
var _react = _interopRequireDefault(require("react"));
var _material = require("@mui/material");
var _consts = require("../../../consts");
var _types = require("../../../types");
var _utils = require("../../../utils");
var _CheckMark = _interopRequireDefault(require("../../CheckMark"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
var BoostMobilePricingCard = function BoostMobilePricingCard(_ref) {
  var _boostProductTierConf;
  var tier = _ref.tier,
    _ref$checkoutTerm = _ref.checkoutTerm,
    checkoutTerm = _ref$checkoutTerm === void 0 ? _types.BoostTerm.YEARLY : _ref$checkoutTerm,
    checkoutTier = _ref.checkoutTier,
    setCheckoutTier = _ref.setCheckoutTier;
  var tierConfig = (_boostProductTierConf = _consts.boostProductTierConfig_v3[checkoutTerm]) === null || _boostProductTierConf === void 0 ? void 0 : _boostProductTierConf[tier];
  var _ref2 = tierConfig || {},
    name = _ref2.name,
    _ref2$price = _ref2.price,
    price = _ref2$price === void 0 ? 0 : _ref2$price,
    _ref2$originalPrice = _ref2.originalPrice,
    originalPrice = _ref2$originalPrice === void 0 ? 0 : _ref2$originalPrice,
    featuresMobile = _ref2.featuresMobile;
  var _calculatePerMonthPri = (0, _utils.calculatePerMonthPrice)(checkoutTerm, price, originalPrice),
    perMonthPrice = _calculatePerMonthPri.perMonthPrice;
  var isSelected = name.toLowerCase() === checkoutTier.toLowerCase();
  return /*#__PURE__*/_react["default"].createElement(_material.Card, {
    sx: {
      padding: "1rem",
      background: isSelected ? "rgba(39, 32, 62, 0.70)" : "rgba(0, 0, 0, 0.50)",
      color: "#FFF",
      border: isSelected ? "3px solid #7249F5" : "2px solid #4B4B4B",
      borderRadius: "10px"
    },
    onClick: function onClick() {
      return setCheckoutTier(_types.BoostTier[name.toUpperCase()]);
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid2, {
    container: true,
    direction: "column",
    sx: {
      marginBottom: isSelected ? "1.5rem" : "0"
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Grid2, {
    container: true,
    direction: "row",
    sx: {
      justifyContent: "space-between"
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    sx: {
      color: isSelected ? "rgba(227, 219, 253, 1)" : "white",
      fontFamily: "Gilroy",
      fontSize: "1.25rem",
      fontStyle: "normal",
      fontWeight: 800,
      lineHeight: "120%",
      letterSpacing: "-0.25px"
    }
  }, name === 'Basic' ? 'Starter' : name, " ", checkoutTerm === _types.BoostTerm.YEARLY ? "Annual" : "Monthly"), /*#__PURE__*/_react["default"].createElement(_material.Box, {
    component: "div"
  }, /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    component: "span",
    sx: {
      color: "#FFF",
      fontFamily: "Gilroy",
      fontSize: "1.25rem",
      fontStyle: "normal",
      fontWeight: 600,
      lineHeight: "120%",
      letterSpacing: "-0.25px"
    }
  }, "$", perMonthPrice.toFixed(2)), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    component: "span",
    sx: {
      color: "#F5F5F5",
      fontFamily: "Gilroy",
      fontSize: "1rem",
      fontStyle: "normal",
      fontWeight: 400,
      lineHeight: "120%",
      letterSpacing: "-0.5px"
    }
  }, "/month"))), name === 'VIP' && isSelected && /*#__PURE__*/_react["default"].createElement("span", null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "mr-1"
  }, "\uD83C\uDF1F"), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    component: "span",
    sx: {
      fontSize: '1rem',
      fontWeight: 'bold',
      background: 'linear-gradient(90deg, #B2C5F0 11.18%, #D8B8F4 98.8%)',
      WebkitBackgroundClip: 'text',
      color: 'transparent'
    }
  }, "Designed for Business Owners"), /*#__PURE__*/_react["default"].createElement("span", {
    className: "ml-1"
  }, "\uD83C\uDF1F"))), /*#__PURE__*/_react["default"].createElement(_material.Collapse, {
    "in": isSelected
  }, /*#__PURE__*/_react["default"].createElement(_material.Stack, {
    spacing: 2
  }, featuresMobile.map(function (feat, featureIdx) {
    var _feat$description;
    return /*#__PURE__*/_react["default"].createElement(_material.Grid2, {
      container: true,
      direction: "row"
    }, /*#__PURE__*/_react["default"].createElement(_material.Stack, {
      direction: "row",
      spacing: 1
    }, /*#__PURE__*/_react["default"].createElement(_CheckMark["default"], {
      width: 16,
      color: "rgba(199, 182, 251, 1)",
      key: featureIdx
    }), (_feat$description = feat.description) === null || _feat$description === void 0 ? void 0 : _feat$description.map(function (_ref3, descriptionIdx) {
      var text = _ref3.text,
        style = _ref3.style;
      return /*#__PURE__*/_react["default"].createElement("span", {
        style: _objectSpread({
          lineHeight: 1.18,
          display: "grid",
          placeItems: "center"
        }, style || {})
      }, text);
    })));
  }))));
};
var BoostMobilePricingTable = exports.BoostMobilePricingTable = function BoostMobilePricingTable(_ref4) {
  var tiers = _ref4.tiers,
    checkoutTier = _ref4.checkoutTier,
    checkoutTerm = _ref4.checkoutTerm,
    setCheckoutTier = _ref4.setCheckoutTier;
  return /*#__PURE__*/_react["default"].createElement(_material.Box, {
    sx: {
      width: "100%"
    }
  }, /*#__PURE__*/_react["default"].createElement(_material.Stack, {
    spacing: 2
  }, tiers.map(function (t) {
    return /*#__PURE__*/_react["default"].createElement(BoostMobilePricingCard, {
      tier: t,
      checkoutTier: checkoutTier,
      checkoutTerm: checkoutTerm,
      setCheckoutTier: setCheckoutTier
    });
  })));
};